import loader from '../partials/loader'

const menu = () => ({
    ...loader,
    loading: false,
    menuVisible: false,
    menu: {
        categories: [],
    },

    init() {
        const params = new URLSearchParams(document.location.search)

        if (params.get('switch_currency') && params.get('switch_currency') === '1') {
            window.Alpine.store('general').showOverlay = true
            window.Alpine.store('general').showGeoModal = true

            params.delete('switch_currency')
        }

        if (this.menuVisible) {
            this.loadMenu()
        }
    },

    showMenu() {
        if (this.menu.categories.length === 0) {
            this.loadMenu()
        }

        this.menuVisible = true
        window.Alpine.store('general').showOverlay = true
    },

    hideMenu() {
        this.menuVisible = false
        window.Alpine.store('general').showOverlay = false
    },

    clickHandler(category, e) {
        if (!category.has_children) {
            window.location.href = category.link
            return
        }
        e.preventDefault()
        this.loadMenu(category.id_category)
    },

    loadMenu(idCategory) {
        if (this.loading) {
            return
        }

        this.startLoader()

        this.$refs.menu.style.minWidth = `${this.$refs.menu.offsetWidth}px`

        this.menu = {
            categories: [],
        }
        window.api
            .get('/api/menu', {
                idCategory,
            })
            .then(response => {
                this.menu = response.data
                // force sirv to refresh images
                window.dispatchEvent(new Event('resize'))
                this.stopLoader()
            })
            .catch(() => {
                this.stopLoader()
            })
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('menu', menu)
})
export default menu
